import React from 'react';
import styled from 'styled-components';

const FoldingStripWrapper = styled.div`
  border-right: 1px solid #d9d9d9;
  background: #fff;
  width: 16px;
  height: 100%;

  &:hover {
    border-right: 2px solid #b3c8ff;
    background: #f2f6ff;
  }
`;

const FoldingStrip: React.FC<any> = ({ children, ...rest }) => {
  return <FoldingStripWrapper {...rest}>{children}</FoldingStripWrapper>;
};

export default FoldingStrip;
